<div class="thumb-for-reward">
    <div class="thumb-for-reward__inner">
        <shared-loader-for-placeholder *ngIf="loading || (src && !imgLoaded)" class="thumb-for-reward__loader">
        </shared-loader-for-placeholder>

        <ng-container *ngIf="!loading && src">
            <div class="thumb-for-reward__holder" [hidden]="!imgLoaded">
                <img directive-image-preload [url]="src" [width]="width" [height]="height" (onLoaded)="onLoaded($event)"
                    class="thumb-for-reward__img" [alt]="title" />
            </div>
        </ng-container>

    </div>
</div>